import { render } from "./InputYear.vue?vue&type=template&id=04049374"
import script from "./InputYear.vue?vue&type=script&lang=js"
export * from "./InputYear.vue?vue&type=script&lang=js"
script.render = render

export default script